import styled from 'styled-components';
import Modal from 'antd/es/modal/Modal';

import { Header1CSS } from 'components/layout/headers';
import { MOBILE_VIEWPORT } from 'modules/theme/config';
import { Text18CSS, TextCSS } from 'components/layout/text';

export const PopupModal = styled(Modal)`
  max-width: 592px;

  .ant-modal-body {
    padding: 32px;
  }

  .popup-message {
    padding-top: 16px;
  }

  .discount-price {
    ${Header1CSS};
    color: ${({ theme }) => theme.colors.primary};
  }

  .secondary-text {
    ${TextCSS};
    color: ${({ theme }) => theme.colors.darkGrey};
  }

  .modal-text {
    ${Text18CSS};
    margin: 8px 0;
    line-height: 1.3;
    text-align: center;
    color: ${({ theme }) => theme.colors.darkGrey};
  }

  @media (max-width: ${MOBILE_VIEWPORT}px) {
    width: 95vw;
    max-width: 80%;
    margin: 5% auto;

    .ant-modal-body {
      padding: 24px;
    }
  }

  @media (max-width: 320px) {
    max-width: 80%;
    margin: 5% auto;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 12px;

  button {
    &.cancel {
      min-width: 30%;
    }

    &.confirm {
      flex: 1;
    }
  }

  @media (max-width: 320px) {
    flex-direction: column;
    button,
    button.cancel,
    button.confirm {
      width: 100%;
      flex: none;
    }
  }
`;

